import { plainToClass } from 'class-transformer';
import {
  API_APPOINTMENT_CANCEL_TYPE_CREATE,
  API_APPOINTMENT_CANCEL_TYPE_DELETE,
  API_APPOINTMENT_CANCEL_TYPE_FIND_ALL,
  API_APPOINTMENT_CANCEL_TYPE_FIND_ONE,
  API_APPOINTMENT_CANCEL_TYPE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { AppointmentCancelTypeDto } from '../dto';
import { FindAllResponse } from '../types';

export class AppointmentCancelTypeApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<AppointmentCancelTypeDto>> {
    return this.httpClient
      .get(API_APPOINTMENT_CANCEL_TYPE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(AppointmentCancelTypeDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<AppointmentCancelTypeDto> {
    return this.httpClient
      .get(API_APPOINTMENT_CANCEL_TYPE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(AppointmentCancelTypeDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<AppointmentCancelTypeDto> {
    return this.httpClient
      .post(API_APPOINTMENT_CANCEL_TYPE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(AppointmentCancelTypeDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<AppointmentCancelTypeDto> {
    return this.httpClient
      .put(API_APPOINTMENT_CANCEL_TYPE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(AppointmentCancelTypeDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_APPOINTMENT_CANCEL_TYPE_DELETE, {
      pathParams: { uuid }
    });
  }
}
